// Local to ProductCard only (not reused by other components), so this stays
// component-scoped instead of living in the global core/configurations.
// Controls how many description characters render before ExpandableText
// truncates the text behind a "Read more" toggle.
export const productCardConfig = {
  descriptionMaxLength: 400,
};

export default productCardConfig;
